import React from 'react';
import { Reveal } from './Reveal';
import { forYouItems } from '../data/content';
export function ForYou() {
  return <section className="bg-ink px-6 py-20" data-id="element-58" data-mp="330keanhbm54v">
      <Reveal data-id="element-59" data-mp="32xg67f0qip8x">
        <h2 className="font-serif text-[32px] font-bold leading-tight text-white" data-id="element-60" data-mp="3gqfjdad1o7db">Elegida es para ti si…</h2>
        <ul className="mt-9 space-y-3" data-id="element-61" data-mp="3bzfk3yggdd7n">
          {forYouItems.map(item => <li key={item} className="rounded-r-lg border-l-[3px] border-blush bg-panel px-6 py-6 text-base leading-relaxed text-white" data-id="element-62" data-mp="3qovctjzjnspz">
              {item}
            </li>)}
        </ul>
      </Reveal>
    </section>;
}